function isvatstatus(){
  const checkBox = document.getElementById("checkbox"),
        incVat = document.getElementsByClassName("iprice-inc"),
        exVat = document.getElementsByClassName("iprice-ex"),
        cookiesName = "ex-vat", 
        cookiesPath = "/",
        cookiesDomain = "insulationuk.co.uk",
        cookiesSecure = false,
        cookiesExpire = new Date(),
        regexPattern = new RegExp("true");
  
  let time = cookiesExpire.getTime(),
      productID = (checkBox.dataset.product != "") ? checkBox.dataset.product : "",
      cookiesValue = true;
  
  time += 3600 * 1000;
  cookiesExpire.setTime(time);

  const exVatValue = regexPattern.test(getCookie(cookiesName));
  if(exVatValue == true){
    checkBox.checked = true;
  }else{
    checkBox.checked = false;
  }

  for (var i = 0; i < incVat.length; i++) {
    if (checkBox.checked == false) {
      cookiesValue = false;
      setCookie(cookiesName,cookiesValue,cookiesExpire,cookiesPath,cookiesDomain,cookiesSecure);
      incVat[i].style.display = "block";
      exVat[i].style.display = "none";
    } else if (checkBox.checked == true) {
      cookiesValue = true;
      setCookie(cookiesName,cookiesValue,cookiesExpire,cookiesPath,cookiesDomain,cookiesSecure);
      incVat[i].style.display = "none";
      exVat[i].style.display = "block";
    }
  }
  checkBox.addEventListener("change", (e) => {
    cookiesValue = false;
    if (checkBox.checked){
      cookiesValue = true;
    }

    for (var i = 0; i < incVat.length; i++) {
    if (checkBox.checked == false) {
      incVat[i].style.display = "block";
      exVat[i].style.display = "none";
    } else if (checkBox.checked == true) {
      incVat[i].style.display = "none";
      exVat[i].style.display = "block";
    }
  }
    
    setCookie(cookiesName,cookiesValue,cookiesExpire,cookiesPath,cookiesDomain,cookiesSecure);
  })

  if(productID != ""){
    document.addEventListener('DOMContentLoaded', function() {
      const variantSelector = document.getElementById("product-select-"+productID)
      variantSelector.addEventListener('change', function() {
        for (var i = 0; i < incVat.length; i++) {
          if (checkBox.checked == false) {
            incVat[i].style.display = "block";
            exVat[i].style.display = "none";
          } else if (checkBox.checked == true) {
            incVat[i].style.display = "none";
            exVat[i].style.display = "block";
          }
        }
      });
    
    })
  }
}
isvatstatus();